import _extends from "@babel/runtime/helpers/extends";
import React from 'react';

// eslint-disable-next-line @atlassian/tangerine/import/entry-points
// Ignored via go/ees005
// eslint-disable-next-line import/no-named-as-default
import Icon from '@atlaskit/icon/base';
var textColorGlyph = function textColorGlyph(props) {
  return (
    /*#__PURE__*/
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement("svg", _extends({}, props, {
      width: "24",
      height: "24",
      xmlns: "http://www.w3.org/2000/svg"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14 12.5h-4l-.874 2.186A.5.5 0 0 1 8.66 15H7.273a.5.5 0 0 1-.456-.705l4.05-9A.5.5 0 0 1 11.323 5h1.354a.5.5 0 0 1 .456.295l4.05 9a.5.5 0 0 1-.456.705h-1.388a.5.5 0 0 1-.465-.314L14 12.5zm-.6-1.5L12 7.5 10.6 11h2.8z",
      fill: "currentColor",
      fillRule: "evenodd"
    }))
  );
};
export var EditorTextColorIcon = function EditorTextColorIcon() {
  return /*#__PURE__*/React.createElement(Icon, {
    glyph: textColorGlyph,
    label: ""
  });
};